var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIconActive(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15.5V3.5C24 2.70435 23.6839 1.94129 23.1213 1.37868C22.5587 0.81607 21.7956 0.5 21 0.5H3C2.20435 0.5 1.44129 0.81607 0.87868 1.37868C0.31607 1.94129 0 2.70435 0 3.5V15.5C0 16.2956 0.31607 17.0587 0.87868 17.6213C1.44129 18.1839 2.20435 18.5 3 18.5H7.5L12 23L16.5 18.5H21C21.7956 18.5 22.5587 18.1839 23.1213 17.6213C23.6839 17.0587 24 16.2956 24 15.5ZM4.5 6.5C4.5 6.10218 4.65804 5.72064 4.93934 5.43934C5.22064 5.15804 5.60218 5 6 5H18C18.3978 5 18.7794 5.15804 19.0607 5.43934C19.342 5.72064 19.5 6.10218 19.5 6.5C19.5 6.89782 19.342 7.27936 19.0607 7.56066C18.7794 7.84196 18.3978 8 18 8H6C5.60218 8 5.22064 7.84196 4.93934 7.56066C4.65804 7.27936 4.5 6.89782 4.5 6.5ZM6 11C5.60218 11 5.22064 11.158 4.93934 11.4393C4.65804 11.7206 4.5 12.1022 4.5 12.5C4.5 12.8978 4.65804 13.2794 4.93934 13.5607C5.22064 13.842 5.60218 14 6 14H10.5C10.8978 14 11.2794 13.842 11.5607 13.5607C11.842 13.2794 12 12.8978 12 12.5C12 12.1022 11.842 11.7206 11.5607 11.4393C11.2794 11.158 10.8978 11 10.5 11H6Z",
    fill: "#1FC7A5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconActive);
export default __webpack_public_path__ + "static/media/ContactIconActive.e68829f1f3014ee9c2384a39f5d77c67.svg";
export { ForwardRef as ReactComponent };